__turbopack_context__.v({
  "content": "native-navigation-module__E_5WdG__content",
  "outlet": "native-navigation-module__E_5WdG__outlet",
  "page": "native-navigation-module__E_5WdG__page",
});
